
import { Typography, Box, Paper, Grid } from "@mui/material"; // Importa los componentes de Material UI para la interfaz
import Link from '@mui/material/Link'; // Importa el componente Link de Material UI para enlaces

export default function ContactUs() { // Define el componente funcional 'ContactUs'
  return (
    <Box marginLeft="10%"> {/* Define un contenedor con margen izquierdo del 10% */}
      <Paper sx={{width:"70%", marginLeft: "10%", marginTop: "7%", paddingTop: "3%", paddingLeft: "5%", paddingBottom: "5%", paddingRight: "5%"}}> 
        {/* Establece el diseño del primer contenedor 'Paper' con márgenes, ancho y padding */}
        <Typography variant="h5" textAlign="center">
          {/* Título principal centrado */}
          Este proyecto es guiado por <br /> <Link href ="https://penelope.matem.unam.mx/">Darío Alatorre</Link> y 
          <Link href="https://www.jaimelobato.com/en/bio/"> Jaime Lobato</Link>
        </Typography><br />
         <Typography variant="h6" textAlign="center"> 
           Ponte en contacto con nosotros a través del correo <br />
          <Link  href="mailto:labvs@im.unam.mx?subject=Hello!%20">labvs@im.unam.mx </Link> {/* Enlace de correo electrónico para contactar con el laboratorio */}
        </Typography>
                <Grid container marginTop="2%"> {/* Contenedor Grid que organiza los elementos de manera flexible */}
          <Grid item xs={4}> {/* Espaciado vacío en el lado izquierdo */}
          </Grid>
          <Grid item xs={4}> {/* Espaciado vacío en el lado derecho */}
          </Grid>
        </Grid>
      </Paper>

    </Box>
  )
}

